import React from "react"

import Panel from "shared/components/Panel"
import styles from "./CovidBanner.css"

function CovidBanner() {
  return (
    <Panel className={styles.root}>
      <div>
        For your information, you may encounter some delays regarding the delivery of your parcel, due to the global health crisis.
      </div>
      <div>
        We do our best to deliver as quickly as possible, but many routes are impacted by the measures taken to curb the spread of COVID-19.
      </div>
    </Panel>
  )
}

export default CovidBanner



// WEBPACK FOOTER //
// ./src/views/Parcel/components/CovidBanner/CovidBanner.js